<template>
    <div :class="layoutContainerClass" @click="onDocumentClick">
        <div class="layout-main">
            <AppTopBar
                v-if="kode"
                :items="filteredMenu"
                :menuMode="menuMode"
                :colorScheme="colorScheme"
                :menuActive="menuActive"
                :topbarMenuActive="topbarMenuActive"
                :activeInlineProfile="activeInlineProfile"
                @topbar-item-click="onTopbarItemClick"
                @menubutton-click="onMenuButtonClick"
                @sidebar-mouse-over="onSidebarMouseOver"
                @sidebar-mouse-leave="onSidebarMouseLeave"
                @toggle-menu="onToggleMenu"
                @change-inlinemenu="onChangeActiveInlineMenu"
                @menu-click="onMenuClick"
                @menuitem-click="onMenuItemClick"
                @root-menuitem-click="onRootMenuItemClick"
            />

            <AppMenu
                v-if="kode"
                :model="filteredMenu"
                :menuMode="menuMode"
                :colorScheme="colorScheme"
                :menuActive="menuActive"
                :sidebarActive="sidebarActive"
                :sidebarStatic="sidebarStatic"
                :pinActive="pinActive"
                :activeInlineProfile="activeInlineProfile"
                @sidebar-mouse-over="onSidebarMouseOver"
                @sidebar-mouse-leave="onSidebarMouseLeave"
                @toggle-menu="onToggleMenu"
                @change-inlinemenu="onChangeActiveInlineMenu"
                @menu-click="onMenuClick"
                @menuitem-click="onMenuItemClick"
                @root-menuitem-click="onRootMenuItemClick"
            />

            <AppBreadcrumb :menuMode="menuMode" v-model:searchActive="searchActive" v-model:searchClick="searchClick" @menubutton-click="onMenuButtonClick" @rightmenu-button-click="onRightMenuButtonClick" />

            <div class="layout-main-content">
                <router-view />
            </div>

            <AppFooter :colorScheme="colorScheme" />
        </div>

        <!-- <AppRightMenu :rightMenuActive="rightMenuActive" @rightmenu-click="onRightMenuClick" @rightmenu-active="onChangeRightMenuActive" /> -->

        <AppConfig
            v-model:menuMode="menuMode"
            :theme="theme"
            :componentTheme="componentTheme"
            :colorScheme="colorScheme"
            :configActive="configActive"
            :configClick="configClick"
            @config-button-click="onConfigButtonClick"
            @config-click="onConfigClick"
            @change-color-scheme="onChangeColorScheme"
            @change-component-theme="onChangeComponentTheme"
            @change-menu-theme="onChangeMenuTheme"
            @change-menu-mode="onChangeMenuMode"
        />
    </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
// import AppRightMenu from './AppRightMenu.vue';
import AppFooter from './AppFooter.vue';
import AppBreadcrumb from './AppBreadcrumb.vue';
import AppConfig from './AppConfig.vue';
import EventBus from './event-bus';

export default {
    emits: ['layout-mode-change', 'menu-theme', 'layoutModeChange', 'sidebar-mouse-over', 'sidebar-mouse-leave', 'change-color-scheme', 'change-component-theme', 'change-menu-theme', 'change-inlinemenu'],
    props: {
        colorScheme: String,
        topbarTheme: String,
        theme: String,
        componentTheme: String,
    },
    data() {
        return {
            search: false,
            searchClick: false,
            searchActive: false,
            // menuMode: 'sidebar',
            menuActive: false,
            activeInlineProfile: false,
            inlineMenuClick: false,
            overlayMenuActive: false,
            topbarMenuActive: false,
            topbarItemClick: false,
            sidebarActive: true,
            sidebarStatic: true,
            pinActive: true,
            staticMenuDesktopInactive: false,
            staticMenuMobileActive: false,
            rightMenuClick: false,
            rightMenuActive: false,
            configActive: false,
            configClick: false,
            menu: [
                {
                    label: 'Dashboard',
                    icon: 'pi pi-fw pi-home',
                    to: '/dashboard',
                },
                {
                    label: 'Master',
                    icon: 'pi pi-fw pi-star-fill',
                    items: [
                        // { label: 'Absensi', icon: 'pi pi-fw pi-circle', to: '/absensi' },
                        { label: 'Agama', icon: 'pi pi-fw pi-circle', to: '/agama' },
                        { label: 'Alat Transportasi', icon: 'pi pi-fw pi-circle', to: '/alat_transportasi' },
                        { label: 'Bidang Minat', icon: 'pi pi-fw pi-circle', to: '/bidang_minat' },
                        { label: 'Dasar Penilaian', icon: 'pi pi-fw pi-circle', to: '/dasar_penilaian' },
                        { label: 'Fakultas', icon: 'pi pi-fw pi-circle', to: '/fakultas' },
                        { label: 'Gedung', icon: 'pi pi-fw pi-circle', to: '/gedung' },
                        // { label: 'Jadwal', icon: 'pi pi-fw pi-circle', to: '/jadwal' },
                        { label: 'Jalur Masuk', icon: 'pi pi-fw pi-circle', to: '/jalur_masuk' },
                        { label: 'Jenis Evaluasi', icon: 'pi pi-fw pi-circle', to: '/jenis_evaluasi' },
                        { label: 'Jenis Keluar', icon: 'pi pi-fw pi-circle', to: '/jenis_keluar' },
                        { label: 'Jenis Substansi', icon: 'pi pi-fw pi-circle', to: '/jenis_substansi' },
                        { label: 'Jenis Tinggal', icon: 'pi pi-fw pi-circle', to: '/jenis_tinggal' },
                        { label: 'Jenjang Pendidikan', icon: 'pi pi-fw pi-circle', to: '/jenjang_pendidikan' },
                        { label: 'Kampus', icon: 'pi pi-fw pi-circle', to: '/kampus' },
                        { label: 'Kategori SKPI', icon: 'pi pi-fw pi-circle', to: '/kategori_skpi' },
                        { label: 'Kebutuhan Khusus', icon: 'pi pi-fw pi-circle', to: '/kebutuhan_khusus' },
                        { label: 'Kegiatan Akademik', icon: 'pi pi-fw pi-circle', to: '/kegiatan_akademik' },
                        // { label: 'KRS Jadwal', icon: 'pi pi-fw pi-circle', to: '/pool_krs_jadwal' },
                        // { label: 'KRS Peserta', icon: 'pi pi-fw pi-circle', to: '/pool_krs_peserta' },
                        // { label: 'Mata Kuliah Semester', icon: 'pi pi-fw pi-circle', to: '/mata_kuliah_semester' },
                        // { label: 'Mata Kuliah Semester Kurikulum', icon: 'pi pi-fw pi-circle', to: '/mata_kuliah_semester_kurikulum' },
                        { label: 'Negara', icon: 'pi pi-fw pi-circle', to: '/negara' },
                        { label: 'Periode Perkuliahan', icon: 'pi pi-fw pi-circle', to: '/periode_perkuliahan' },
                        { label: 'Pekerjaan', icon: 'pi pi-fw pi-circle', to: '/pekerjaan' },
                        { label: 'Pembiayaan', icon: 'pi pi-fw pi-circle', to: '/pembiayaan' },
                        { label: 'Penghasilan', icon: 'pi pi-fw pi-circle', to: '/penghasilan' },
                        { label: 'Perwalian', icon: 'pi pi-fw pi-circle', to: '/ms_perwalian' },
                        { label: 'Program Studi', icon: 'pi pi-fw pi-circle', to: '/prodi' },
                        { label: 'Ruangan', icon: 'pi pi-fw pi-circle', to: '/ruangan' },
                        { label: 'Role', icon: 'pi pi-fw pi-circle', to: '/role' },
                        { label: 'Semester', icon: 'pi pi-fw pi-circle', to: '/semester' },
                        { label: 'SKKM', icon: 'pi pi-fw pi-circle', to: '/master_skkm' },
                        { label: 'Status Mahasiswa', icon: 'pi pi-fw pi-circle', to: '/status_mahasiswa' },
                        { label: 'Tahun Ajaran', icon: 'pi pi-fw pi-circle', to: '/tahun_ajaran' },
                        { label: 'Wilayah', icon: 'pi pi-fw pi-circle', to: '/wilayah' },
                    ],
                    role: ['99'],
                },
                {
                    label: 'Pencarian Mahasiswa',
                    icon: 'pi pi-fw pi-user',
                    to: '/pencarian_mahasiswa',
                    role: ['99', 'OPP', 'OPADAK'],
                },
                {
                    label: 'Absensi',
                    icon: 'pi pi-fw pi-user',
                    to: '/absensi',
                    role: ['99', 'OPP', 'DS'],
                },
                {
                    label: 'Users',
                    icon: 'pi pi-fw pi-user',
                    items: [
                        { label: 'Data Users', icon: 'pi pi-fw pi-circle', to: '/users' },
                        // { label: 'Kelas Dosen', icon: 'pi pi-fw pi-circle', to: '/dosen_kelas' },
                    ],
                    role: ['99'],
                },
                {
                    label: 'Dosen',
                    icon: 'pi pi-fw pi-user',
                    items: [
                        { label: 'Data Dosen', icon: 'pi pi-fw pi-circle', to: '/dosen' },
                        { label: 'Kelas Dosen', icon: 'pi pi-fw pi-circle', to: '/dosen_kelas' },
                    ],
                    role: ['99', 'OPP', 'KPRO', 'OPADAK', 'OPJ'],
                },
                {
                    label: 'Mahasiswa',
                    icon: 'pi pi-fw pi-user',
                    items: [
                        { label: 'Data Mahasiswa', icon: 'pi pi-fw pi-circle', to: '/mahasiswa' },
                        // { label: 'Kelas Mahasiswa', icon: 'pi pi-fw pi-circle', to: '/mahasiswa_kelas' },
                        { label: 'SKPI', icon: 'pi pi-fw pi-circle', to: '/skpi' },
                        { label: 'SKKM Mahasiswa', icon: 'pi pi-fw pi-circle', to: '/skkm_mahasiswa' },
                        { label: 'Perwalian', icon: 'pi pi-fw pi-circle', to: '/perwalian' },
                        { label: 'Lulus / DO Mahasiswa', icon: 'pi pi-fw pi-circle', to: '/lulus_do' },
                    ],
                    role: ['99', 'OPP', 'KPRO', 'OPADAK', 'OPJ'],
                },
                {
                    label: 'Kalender Akademik',
                    icon: 'pi pi-fw pi-briefcase',
                    items: [
                        { label: 'Kalender Akademik', icon: 'pi pi-fw pi-circle', to: '/kalender_akademik' },
                        { label: 'Periode Perkualiahan', icon: 'pi pi-fw pi-circle', to: '/periode_perkuliahan' },
                    ],
                    role: ['99', 'OPP', 'OPADAK'],
                },
                {
                    label: 'Her Registrasi',
                    icon: 'pi pi-fw pi-briefcase',
                    items: [
                        { label: 'Data Registrasi', icon: 'pi pi-fw pi-circle', to: '/her_registrasi' },
                        { label: 'Data Registrasi Cuti', icon: 'pi pi-fw pi-circle', to: '/her_reg_cuti' },
                        { label: 'Data Belum Registrasi', icon: 'pi pi-fw pi-circle', to: '/belum_her_registrasi' },
                        { label: 'Pengajuan Cuti Mahasiswa', icon: 'pi pi-fw pi-circle', to: '/cuti' },
                        { label: 'Tidak Aktif', icon: 'pi pi-fw pi-circle', to: '/tidak_aktif' },
                        { label: 'Menunggu Lulus', icon: 'pi pi-fw pi-circle', to: '/menunggu_lulus' },
                        { label: 'Billing Mahasiswa', icon: 'pi pi-fw pi-circle', to: '/billing_mahasiswa' },
                    ],

                    role: ['99', 'OPP', 'OPADAK', 'KPRO', 'OPJ'],
                },
                {
                    label: 'Perkuliahan',
                    icon: 'pi pi-fw pi-briefcase',
                    items: [
                        { label: 'Mata Kuliah', icon: 'pi pi-fw pi-circle', to: '/mata_kuliah' },
                        { label: 'Substansi Kuliah', icon: 'pi pi-fw pi-circle', to: '/substansi_kuliah' },
                        { label: 'Kurikulum', icon: 'pi pi-fw pi-circle', to: '/kurikulum' },
                        { label: 'Mata Kuliah Kurikulum', icon: 'pi pi-fw pi-circle', to: '/mata_kuliah_kurikulum' },
                        { label: 'Kelas Kuliah', icon: 'pi pi-fw pi-circle', to: '/kelas_kuliah' },
                        { label: 'Penjadwalan', icon: 'pi pi-fw pi-circle', to: '/perjadwalan' },
                        { label: 'UAS', icon: 'pi pi-fw pi-circle', to: '/uas' },
                        { label: 'UTS', icon: 'pi pi-fw pi-circle', to: '/uts' },
                        { label: 'Paket KRS', icon: 'pi pi-fw pi-circle', to: '/paket_krs' },
                    ],
                    role: ['99', 'OPP', 'OPADAK'],
                },
                {
                    label: 'Nilai',
                    icon: 'pi pi-fw pi-briefcase',
                    items: [
                        { label: 'Manajemen Nilai', icon: 'pi pi-fw pi-circle', to: '/manajemen_nilai' },
                        { label: 'Skala Nilai Prodi', icon: 'pi pi-fw pi-circle', to: '/skala_nilai_prodi' },
                    ],
                    role: ['99', 'OPP', 'DS'],
                },

                {
                    label: 'Tugas Akhir',
                    icon: 'pi pi-fw pi-briefcase',
                    items: [
                        { label: 'Pengajuan Judul', icon: 'pi pi-fw pi-circle', to: '/pengajuan_tugas_akhir' },
                        { label: 'Pengajuan Ujian', icon: 'pi pi-fw pi-circle', to: '/ujian_akhir' },
                    ],
                    role: ['99', 'OPP', 'KPRO', 'OPADAK'],
                },
                {
                    label: 'Nilai Mahasiswa',
                    icon: 'pi pi-fw pi-user',
                    to: '/nilai_mahasiswa',
                    role: ['99', 'DS'],
                },
                {
                    label: 'Wisuda',
                    icon: 'pi pi-fw pi-briefcase',
                    items: [
                        { label: 'Periode Wisuda', icon: 'pi pi-fw pi-circle', to: '/periode_wisuda' },
                        { label: 'Peserta Wisuda', icon: 'pi pi-fw pi-circle', to: '/peserta_wisuda' },
                    ],
                    role: ['99', 'OPP', 'OPADAK', 'OPPUS'],
                },
                {
                    label: 'Penjaminan Mutu',
                    icon: 'pi pi-fw pi-briefcase',
                    items: [
                        { label: 'Akreditas Prodi', icon: 'pi pi-fw pi-circle', to: '/akreditas_prodi' },
                        { label: 'Profil PT', icon: 'pi pi-fw pi-circle', to: '/profil_pt' },
                    ],
                    role: ['99', 'OPP'],
                },
                {
                    label: 'Management Ruangan',
                    icon: 'pi pi-fw pi-briefcase',
                    items: [
                        { label: 'Jadwal Ruangan', icon: 'pi pi-fw pi-circle', to: '/jadwal_ruangan' },
                        { label: 'Booking', icon: 'pi pi-fw pi-circle', to: '/list_booking' },
                    ],
                    role: ['99'],
                },
                // {
                //     label: 'SKPI',
                //     icon: 'pi pi-fw pi-user',
                //     to: '/skpi',
                // },
                // {
                //     label: 'SKKM',
                //     icon: 'pi pi-fw pi-user',
                //     to: '/skkm',
                // },
                // {
                //     label: 'Wisuda',
                //     icon: 'pi pi-fw pi-user',
                //     to: '/wisuda',
                // },
            ],
        };
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    methods: {
        onDocumentClick() {
            if (!this.searchClick && this.searchActive) {
                this.onSearchHide();
            }

            if (!this.topbarItemClick) {
                this.topbarMenuActive = false;
            }

            if (!this.menuClick) {
                if (this.isHorizontal() || this.isSlim()) {
                    this.menuActive = false;
                    EventBus.emit('reset-active-index');
                }

                if (this.overlayMenuActive || this.staticMenuMobileActive) {
                    this.overlayMenuActive = false;
                    this.staticMenuMobileActive = false;
                }

                this.hideOverlayMenu();
                this.unblockBodyScroll();
            }

            if (!this.rightMenuClick) {
                this.rightMenuActive = false;
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            this.topbarItemClick = false;
            this.menuClick = false;
            this.configClick = false;
            this.rightMenuClick = false;
            this.searchClick = false;
            this.inlineMenuClick = false;
        },
        onSearchHide() {
            this.searchActive = false;
            this.searchClick = false;
        },
        onSidebarMouseOver() {
            if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
                this.sidebarActive = this.isDesktop();
                setTimeout(() => {
                    this.pinActive = this.isDesktop();
                }, 200);
            }
        },
        onSidebarMouseLeave() {
            if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
                setTimeout(() => {
                    this.sidebarActive = false;
                    this.pinActive = false;
                }, 250);
            }
        },
        hideOverlayMenu() {
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
        },
        onMenuButtonClick(event) {
            this.menuClick = true;

            if (this.isOverlay()) {
                this.overlayMenuActive = !this.overlayMenuActive;
            }

            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }

            event.preventDefault();
        },
        onTopbarItemClick(event) {
            this.topbarItemClick = true;
            this.topbarMenuActive = !this.topbarMenuActive;
            this.hideOverlayMenu();
            event.preventDefault();
        },
        onRightMenuButtonClick() {
            this.rightMenuClick = true;
            this.rightMenuActive = true;
        },
        onRightMenuClick() {
            this.rightMenuClick = true;
        },
        onMenuClick() {
            this.menuClick = true;
        },
        onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        onMenuItemClick(event) {
            if (!event.item.items) {
                this.hideOverlayMenu();
                EventBus.emit('reset-active-index');
            }

            if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
                this.menuActive = false;
            }
        },
        onChangeMenuMode(menuMode) {
            this.$store.commit('changeMenuMode', menuMode);
            this.overlayMenuActive = false;
        },
        onConfigClick() {
            this.configClick = true;
        },
        onConfigButtonClick(event) {
            this.configActive = !this.configActive;
            this.configClick = true;
            event.preventDefault();
        },
        onChangeRightMenuActive(active) {
            this.rightMenuActive = active;
        },
        onChangeMenuTheme(theme) {
            this.$emit('change-menu-theme', theme);
        },
        onChangeComponentTheme(theme) {
            this.$emit('change-component-theme', theme);
        },
        onChangeColorScheme(scheme) {
            this.$emit('change-color-scheme', scheme);
        },
        onToggleMenu(event) {
            this.menuClick = true;

            if (this.overlayMenuActive) {
                this.overlayMenuActive = false;
            }

            if (this.sidebarActive) {
                this.sidebarStatic = !this.sidebarStatic;
            }

            event.preventDefault();
        },
        onChangeActiveInlineMenu() {
            this.activeInlineProfile = !this.activeInlineProfile;
        },
        blockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        },
        unblockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
            }
        },
        isHorizontal() {
            return this.menuMode === 'horizontal';
        },
        isSlim() {
            return this.menuMode === 'slim';
        },
        isOverlay() {
            return this.menuMode === 'overlay';
        },
        isStatic() {
            return this.menuMode === 'static';
        },
        isSidebar() {
            return this.menuMode === 'sidebar';
        },
        isDesktop() {
            return window.innerWidth > 991;
        },
        isMobile() {
            return window.innerWidth <= 991;
        },
    },
    computed: {
        menuMode() {
            return this.$store.state.simadu.menuMode;
        },
        kode() {
            return this.$store.state.simadu.role_aktif;
        },
        layoutContainerClass() {
            return [
                'layout-wrapper',
                {
                    'layout-static': this.menuMode === 'static',
                    'layout-overlay': this.menuMode === 'overlay',
                    'layout-overlay-active': this.overlayMenuActive,
                    'layout-slim': this.menuMode === 'slim',
                    'layout-horizontal': this.menuMode === 'horizontal',
                    'layout-active': this.menuActive,
                    'layout-mobile-active': this.staticMenuMobileActive,
                    'layout-sidebar': this.menuMode === 'sidebar',
                    'layout-sidebar-static': this.menuMode === 'sidebar' && this.sidebarStatic,
                    'layout-static-inactive': this.staticMenuDesktopInactive && this.menuMode === 'static',
                    'p-ripple-disabled': this.$primevue.config.ripple === false,
                },
            ];
        },
        filteredMenu() {
            if (this.$store.state.simadu.simadu_role && this.$store.state.simadu.role_aktif) {
                return this.menu.filter((item) => {
                    if (item.items) {
                        item.items.filter((ele) => {
                            return !ele.role || ele.role.includes(this.$store.state.simadu.role_aktif.kode_role);
                        });
                    }
                    return !item.role || item.role.includes(this.$store.state.simadu.role_aktif.kode_role);
                });
            } else {
                return this.menu;
            }
        },
    },
    components: {
        AppTopBar,
        AppMenu,
        // AppRightMenu,
        AppFooter,
        AppBreadcrumb,
        AppConfig,
    },
};
</script>
